import * as React from 'react';
import { HelpContainerOpenMobile, HelpWrapper, HelpList, HelpListItem, HelpContainer, HelpClose, HelpContent, HelpOpenMobile } from './styled';
import { Link } from 'react-router-dom';

import {FormattedMessage} from 'react-intl';

const Help: React.FunctionComponent = () => {
  const [tabIndex, setTabIndex] = React.useState<number>(0);
  const [helpActive, setHelpActive] = React.useState<boolean>(false);

  const openTab = (index: number) => {
    setHelpActive(true);
    setTabIndex(index);
  }

  const closeTab = () => {
    setHelpActive(false);
  }

  return <HelpWrapper>
    <HelpList active={helpActive == true}>
      <HelpListItem active={tabIndex == 0}><a onClick={() => openTab(0)}><FormattedMessage id="help_txt_menu_help"/></a></HelpListItem>
      <HelpListItem active={tabIndex == 1}><a onClick={() => openTab(1)}><FormattedMessage id="help_txt_menu_about"/></a></HelpListItem>
      <HelpListItem active={tabIndex == 2}><a onClick={() => openTab(2)}><FormattedMessage id="help_txt_menu_contact"/></a></HelpListItem>
    </HelpList>
    <HelpContainerOpenMobile>
      <HelpOpenMobile onClick={() => openTab(0)} active={helpActive == true} />
    </HelpContainerOpenMobile>
    
    <HelpContainer active={helpActive == true}>
        <HelpContent>
        {tabIndex == 0 && <div>
          <h1><FormattedMessage id="help_txt_menu_help"/></h1>
          <FormattedMessage id="help_txt_text_help"/>
        </div>}

        {tabIndex == 1 && <div>
          <h1><FormattedMessage id="help_txt_menu_about"/></h1>
          <FormattedMessage id="help_txt_text_about"/>
        </div>}

        {tabIndex == 2 && <div>
          <h1><FormattedMessage id="help_txt_menu_contact"/></h1>
          <FormattedMessage id="help_txt_text_contact"/>
        </div>}
        </HelpContent>
        <HelpClose onClick={() => closeTab()}></HelpClose>
    </HelpContainer>
  </HelpWrapper>;
}

export default Help;
